import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;
function ItemSucursalRe(props) {
    const { sucursal, actualizar, regional, fecha, idUsuario,callback } = props;
    const [error, setError] = useState({});
    const [datos, setDatos] = useState({});
    const [cargando, setCargando] = useState(false);
    function getInventario() {
        fetch(`${server}/reporte/getMovimientoPolloHisto`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, ...sucursal, idAlmacen: 1, fecha, idUsuario
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    var datos = data.ok.suc.filter((dt) => [10, 11, 12, 13, 14, 15, 158, 159, 160, 134, 121, 122, 187, -3, 2, 3, 4, 5, 6, 7, 8, 9, 259, 401, 1040, 1041, 1042, 111, 165, 1801].indexOf(parseInt(dt.ID_PROD_ORIGINAL)) !== -1)
                    var resultado = {}
                    if (sucursal.CAMPO == null || sucursal.CAMPO == undefined) {
                        resultado = {
                            'PIPOCA': datos.filter(item => item.ID_PROD_ORIGINAL === 134)[0], 'PIPOC': datos.filter((item) => item.ID_PROD_ORIGINAL === 187)[0],
                            'HMANGO': datos.filter(item => item.ID_PROD_ORIGINAL ===159)[0]
                            , 'HFRUT': datos.filter(item => item.ID_PROD_ORIGINAL === 160)[0],
                            'HMARA': datos.filter(item => item.ID_PROD_ORIGINAL === 158)[0]
                            , 'ARROZ': datos.filter(item => item.ID_PROD_ORIGINAL === 121)[0], 'FRIJOL': datos.filter(item => item.ID_PROD_ORIGINAL === 122)[0],
                            'PAPA': datos.filter(item => [111, 165, 1801].indexOf(item.ID_PROD_ORIGINAL) !== -1), 'BANDEJA': datos.filter(item => item.ID_PROD_ORIGINAL === -3)[0]
                            , 'PIEP': datos.filter((item) => [10, 11].indexOf(item.ID_PROD_ORIGINAL) !== -1), 'PEAL': datos.filter((item) => [12, 13].indexOf(item.ID_PROD_ORIGINAL) !== -1)
                            , 'PIEPM': datos.filter((item) => [6, 7].indexOf(item.ID_PROD_ORIGINAL) !== -1), 'PEALM': datos.filter((item) => [8, 9].indexOf(item.ID_PROD_ORIGINAL) !== -1)
                            , 'PIEPC': datos.filter((item) => [2, 3].indexOf(item.ID_PROD_ORIGINAL) !== -1), 'PEALC': datos.filter((item) => [4, 5].indexOf(item.ID_PROD_ORIGINAL) !== -1)
                        };
                    } else {
                        resultado = {
                            'PIPOCA': datos.filter(item => item.ID_PROD_ORIGINAL === 134)[0], 'PIPOC': datos.filter((item) => item.ID_PROD_ORIGINAL === 187)[0],
                            'HMANGO': datos.filter(item => item.ID_PROD_ORIGINAL === 1042)[0]
                            , 'HFRUT': datos.filter(item => item.ID_PROD_ORIGINAL === 1040)[0],
                            'HMARA': datos.filter(item => item.ID_PROD_ORIGINAL === 1041)[0]
                            , 'ARROZ': datos.filter(item => item.ID_PROD_ORIGINAL === 121)[0], 'FRIJOL': datos.filter(item => item.ID_PROD_ORIGINAL === 122)[0],
                            'PAPA': datos.filter(item => [111, 165, 1801].indexOf(item.ID_PROD_ORIGINAL) !== -1), 'BANDEJA': datos.filter(item => item.ID_PROD_ORIGINAL === -3)[0]
                            , 'PIEP': datos.filter((item) => [10, 11].indexOf(item.ID_PROD_ORIGINAL) !== -1), 'PEAL': datos.filter((item) => [12, 13].indexOf(item.ID_PROD_ORIGINAL) !== -1)
                            , 'PIEPM': datos.filter((item) => [6, 7].indexOf(item.ID_PROD_ORIGINAL) !== -1), 'PEALM': datos.filter((item) => [8, 9].indexOf(item.ID_PROD_ORIGINAL) !== -1)
                            , 'PIEPC': datos.filter((item) => [2, 3].indexOf(item.ID_PROD_ORIGINAL) !== -1), 'PEALC': datos.filter((item) => [4, 5].indexOf(item.ID_PROD_ORIGINAL) !== -1)
                        };
                    }
                    setDatos(resultado);
                    //console.log(resultado);
                } else {
                    setError({ error: 'ERR' })
                }
                setCargando(false);
                callback();
            })
            .catch(error => MsgUtils.msgError(error));
    }
    function sumarProductos(lista) {
        var suma = 0;
        for (var listai of lista) {
            suma += listai.VENTAS_ORIGINAL
        }
        return suma.toFixed(2);
    }
    useEffect(() => {
        setError({});
        setCargando(true);
        getInventario()
    }, [actualizar])
    return (
        <tr >
            <th className='text-center' style={{ width: '120px' }}>{sucursal.SUCURSAL}</th>
            {cargando && [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => {
                return (
                    <td className='text-center' key={item} style={{ fontSize: '19px', width: '100px' }}><i className="fa-solid fa-spinner fa-spin"></i></td>
                )
            })}
            {!cargando && error.error === undefined
                && datos.PEAL !== undefined && datos.PEAL.length > 1
                && datos.PEALM !== undefined && datos.PEALM.length > 1
                && datos.PEALC !== undefined && datos.PEALC.length > 1 &&
                <td className='text-center' style={{ fontSize: '19px', width: '100px' }}>
                <span className='badge rounded-pill bg-light text-dark'>
                {((datos.PEAL[0].VENTAS_ORIGINAL + datos.PEAL[1].VENTAS_ORIGINAL +
                    datos.PEALM[0].VENTAS_ORIGINAL + datos.PEALM[1].VENTAS_ORIGINAL +
                    datos.PEALC[0].VENTAS_ORIGINAL + datos.PEALC[1].VENTAS_ORIGINAL) / 2).toFixed(0)}
                </span></td>}
            {!cargando && error.error !== undefined &&
                <td className='text-center' style={{ fontSize: '19px', width: '100px' }}><span className='badge rounded-pill btnActivo'>{error.error}</span></td>}
            {!cargando && error.error === undefined
                && datos.PIEP !== undefined && datos.PIEP.length > 1
                && datos.PIEPM !== undefined && datos.PIEPM.length > 1
                && datos.PIEPC !== undefined && datos.PIEPC.length > 1 &&
                <td className='text-center' style={{ fontSize: '19px', width: '100px' }}>
                <span className='badge rounded-pill bg-light text-dark'>
                    {((datos.PIEP[0].VENTAS_ORIGINAL + datos.PIEP[1].VENTAS_ORIGINAL +
                        datos.PIEPM[0].VENTAS_ORIGINAL + datos.PIEPM[1].VENTAS_ORIGINAL +
                        datos.PIEPC[0].VENTAS_ORIGINAL + datos.PIEPC[1].VENTAS_ORIGINAL) / 2).toFixed(0)}
                </span></td>}
            {!cargando && error.error !== undefined &&
                <td className='text-center' style={{ fontSize: '19px', width: '100px' }}><span className='badge rounded-pill btnActivo'>{error.error}</span></td>}
            {!cargando && error.error === undefined
                && datos.PEAL !== undefined && datos.PEAL.length > 1
                && datos.PEALM !== undefined && datos.PEALM.length > 1
                && datos.PEALC !== undefined && datos.PEALC.length > 1
                && datos.PIEP !== undefined && datos.PIEP.length > 1
                && datos.PIEPM !== undefined && datos.PIEPM.length > 1
                && datos.PIEPC !== undefined && datos.PIEPC.length > 1 &&
                <td className='text-center' style={{ fontSize: '19px', width: '100px' }}>
                    <span className='badge rounded-pill bg-light text-dark'>
                        {parseInt((datos.PEAL[0].VENTAS_ORIGINAL + datos.PEAL[1].VENTAS_ORIGINAL +
                            datos.PEALM[0].VENTAS_ORIGINAL + datos.PEALM[1].VENTAS_ORIGINAL +
                            datos.PEALC[0].VENTAS_ORIGINAL + datos.PEALC[1].VENTAS_ORIGINAL +
                            datos.PIEP[0].VENTAS_ORIGINAL + datos.PIEP[1].VENTAS_ORIGINAL +
                            datos.PIEPM[0].VENTAS_ORIGINAL + datos.PIEPM[1].VENTAS_ORIGINAL +
                            datos.PIEPC[0].VENTAS_ORIGINAL + datos.PIEPC[1].VENTAS_ORIGINAL) / 100)
                            + '+' + parseInt((datos.PEAL[0].VENTAS_ORIGINAL + datos.PEAL[1].VENTAS_ORIGINAL +
                                datos.PEALM[0].VENTAS_ORIGINAL + datos.PEALM[1].VENTAS_ORIGINAL +
                                datos.PEALC[0].VENTAS_ORIGINAL + datos.PEALC[1].VENTAS_ORIGINAL +
                                datos.PIEP[0].VENTAS_ORIGINAL + datos.PIEP[1].VENTAS_ORIGINAL +
                                datos.PIEPM[0].VENTAS_ORIGINAL + datos.PIEPM[1].VENTAS_ORIGINAL +
                                datos.PIEPC[0].VENTAS_ORIGINAL + datos.PIEPC[1].VENTAS_ORIGINAL) % 100)}
                    </span>
                </td>}
            {!cargando && error.error !== undefined && <td className='text-center' style={{ fontSize: '19px', width: '100px' }}><span className='badge rounded-pill btnActivo'>{error.error}</span></td>}
            {!cargando && error.error === undefined && datos.PIPOC !== undefined && datos.PIPOCA !== undefined &&
                <td className='text-center' style={{ fontSize: '19px', width: '100px' }}>
                    <span className='badge rounded-pill bg-light text-dark'>
                        {datos.PIPOC.VENTAS_ORIGINAL + datos.PIPOCA.VENTAS_ORIGINAL}
                    </span>
                </td>}
            {!cargando && error.error !== undefined && <td className='text-center' style={{ fontSize: '19px', width: '100px' }}><span className='badge rounded-pill btnActivo'>{error.error}</span></td>}
            {!cargando && error.error === undefined && datos.PAPA !== undefined &&
                <td className='text-center' style={{ fontSize: '19px', width: '100px' }}>
                    <span className='badge rounded-pill bg-light text-dark'>
                        {sumarProductos(datos.PAPA)}
                    </span>
                </td>}
            {!cargando && error.error !== undefined && <td className='text-center' style={{ fontSize: '19px', width: '100px' }}><span className='badge rounded-pill btnActivo'>{error.error}</span></td>}
            {!cargando && error.error === undefined && datos.ARROZ !== undefined &&
                <td className='text-center' style={{ fontSize: '19px', width: '100px' }}>
                    <span className='badge rounded-pill bg-light text-dark'>
                        {datos.ARROZ.VENTAS_ORIGINAL}
                    </span>
                </td>}
            {!cargando && error.error !== undefined && <td className='text-center' style={{ fontSize: '19px', width: '100px' }}><span className='badge rounded-pill btnActivo'>{error.error}</span></td>}
            {!cargando && error.error === undefined && datos.FRIJOL !== undefined &&
                <td className='text-center' style={{ fontSize: '19px', width: '100px' }}>
                    <span className='badge rounded-pill bg-light text-dark'>
                        {datos.FRIJOL.VENTAS_ORIGINAL}
                    </span>
                </td>}
            {!cargando && error.error !== undefined && <td className='text-center' style={{ fontSize: '19px', width: '100px' }}><span className='badge rounded-pill btnActivo'>{error.error}</span></td>}
            {!cargando && error.error === undefined && datos.HFRUT !== undefined &&
                <td className='text-center' style={{ fontSize: '19px', width: '100px' }}>
                    <span className='badge rounded-pill bg-light text-dark'>
                        {(datos.HFRUT.VENTAS_ORIGINAL).toFixed(2)}
                    </span>
                </td>}
            {!cargando && error.error !== undefined && <td className='text-center' style={{ fontSize: '19px', width: '100px' }}><span className='badge rounded-pill btnActivo'>{error.error}</span></td>}
            {!cargando && error.error === undefined && datos.HMARA !== undefined &&
                <td className='text-center' style={{ fontSize: '19px', width: '100px' }}>
                    <span className='badge rounded-pill bg-light text-dark'>
                        {(datos.HMARA.VENTAS_ORIGINAL).toFixed(2)}
                    </span>
                </td>}
            {!cargando && error.error !== undefined && <td className='text-center' style={{ fontSize: '19px', width: '100px' }}><span className='badge rounded-pill btnActivo'>{error.error}</span></td>}
            {!cargando && error.error === undefined && datos.HMANGO !== undefined &&
                <td className='text-center' style={{ fontSize: '19px', width: '100px' }}>
                    <span className='badge rounded-pill bg-light text-dark'>
                        {(datos.HMANGO.VENTAS_ORIGINAL).toFixed(2)}
                    </span>
                </td>}
            {!cargando && error.error !== undefined && <td className='text-center' style={{ fontSize: '19px', width: '100px' }}><span className='badge rounded-pill btnActivo'>{error.error}</span></td>}
        </tr>
    )
}

export default ItemSucursalRe